import { useLocation, useNavigate } from "react-router-dom";
import { useMap } from "../../../context/map";
import { useRoot } from "../../../context/root"

export const useSearchInThisArea = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const { mapRefresh, isLoading, rootDispatch, isMapMoving } = useRoot();
  const { mapContext } = useMap();

  const handleClick = () => {
    rootDispatch({
      type: "setDataList",
      data: []
    });
    rootDispatch({
      type: "setDataMarkers",
      data: []
    });
    rootDispatch({
      type: "setExtraMarker",
      data: null,
      mapContext
    });
    mapRefresh();
    navigator({
      pathname: `${process.env.REACT_APP_INTERNAL_URL}`,
      search: searchParams.toString()
    })
  }

  return {
    handleClick,
    isLoading: isMapMoving || isLoading
  }
}
